import React from 'react';
import { DropDownBox } from '@apply/components';

export const ClosedMonthDropDownBox: React.FC<{
    closedMonth: string | null;
    set_closedMonth: (value: string) => void;
    dashboardClosedAvailableClosedMonths: { key: string; display: string }[];
}> = ({ closedMonth, set_closedMonth, dashboardClosedAvailableClosedMonths }) => {
    return (
        <DropDownBox
            id='closedMonthDropDownBox'
            value={closedMonth}
            onChange={set_closedMonth}
            dataSource={dashboardClosedAvailableClosedMonths}
            displayExpr='display'
            valueExpr='key'
            width='180px'
            height='32px'
        />
    );
};
